import { combineReducers } from 'redux';
import isFetchingComments from './isFetchingComments';
import isFetchingCommentsFailed from './isFetchingCommentsFailed';
import isCommentPosting from './isCommentPosting';
import isCommentPostingFailed from './isCommentPostingFailed';
import replyCommentIDs from './replyCommentIDs';
import replyFailedCommentIDs from './replyFailedCommentIDs';
import deleteCommentIDs from './deleteCommentIDs';
import deleteFailedCommentIDs from './deleteFailedCommentIDs';
import deleteReplyIDs from './deleteReplyIDs';
import deleteFailedReplyIDs from './deleteFailedReplyIDs';
import fetchRepliesCommentIDs from './fetchRepliesCommentIDs';
import fetchRepliesFailedCommentIDs from './fetchRepliesFailedCommentIDs';


export default combineReducers({
  isFetchingComments,
  isFetchingCommentsFailed,
  isCommentPosting,
  isCommentPostingFailed,
  replyCommentIDs,
  replyFailedCommentIDs,
  deleteCommentIDs,
  deleteFailedCommentIDs,
  deleteReplyIDs,
  deleteFailedReplyIDs,
  fetchRepliesCommentIDs,
  fetchRepliesFailedCommentIDs,
});
